import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ClientComponent } from './client/client.component';
import { StandardRatesComponent } from './standard-rates/standard-rates.component';
import { ConveyanceRatesComponent } from './conveyance-rates/conveyance-rates.component';
import { BranchHolidaysComponent } from './branch-holidays/branch-holidays.component';
import { CompanyConfigComponent } from './company-config/company-config.component';
import { ArticleStipendComponent } from './article-stipend/article-stipend.component';
import { ManpowerBudgetComponent } from './manpower-budget/manpower-budget.component';
import { MyPipesModule } from '../common/my-pipes.module';
import { ComponentCanDeactivateGuard } from '../guard/component.can-deactivate.guard';
import { ManageAnnouncementComponent } from './manage-announcement/manage-announcement.component';
import { ManageAnnouncementHistoryComponent } from './manage-announcement-history/manage-announcement-history.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ManagementInformationSystemComponent } from './management-information-system/management-information-system.component';
import { DndDirective } from './management-information-system/file-upload-directive/dnd.directive';

@NgModule({
  declarations: [ ClientComponent,ConveyanceRatesComponent, StandardRatesComponent, BranchHolidaysComponent, CompanyConfigComponent, ArticleStipendComponent, ManpowerBudgetComponent, ManageAnnouncementComponent, ManageAnnouncementHistoryComponent, ManagementInformationSystemComponent, DndDirective],
  imports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    MyPipesModule,
    AngularEditorModule
  ],
  providers: [
    ComponentCanDeactivateGuard
  ]
})
export class OrganizationSetupModule { }
